import { CutCopyPaste } from './cut-copy-paste'

export * from './cut-copy-paste'

export default CutCopyPaste